export const pl = {
  'lang.name': 'Polski',
  'lang.select': 'Język',
  'app.skip': 'Pomiń do treści',
  'theme.select': 'Schemat',
  'settings.title': 'Ustawienia',
  'settings.kicker': 'Szybkie',
  'settings.openAria': 'Otwórz ustawienia',
  'settings.closeAria': 'Zamknij ustawienia',
  'settings.backAria': 'Powrót',
  'settings.soundLabel': 'Dźwięk',
  'settings.soundHint': 'Efekty dźwiękowe w grze.',
  'settings.soundAria': 'Przełącz dźwięki',
  'settings.hapticsLabel': 'Wibracje',
  'settings.hapticsHint': 'Wibracje dopasowane do rzutów, fury i zapisu.',
  'settings.hapticsAria': 'Przełącz wibracje',
  'settings.themeLabel': 'Schemat kolorów',
  'settings.typographyLabel': 'Motyw',
  'settings.languageLabel': 'Język',
  'settings.refreshAction': 'Odśwież',
  'settings.refreshing': 'Odświeżam…',
  'settings.refreshDone': 'Odświeżono',
  'settings.refreshFailed': 'Brak danych',
  'theme.name.deep-sea': 'Głęboki ocean',
  'theme.name.ember-sunset': 'Żar zachodu',
  'theme.name.sage-meadow': 'Szałwiowa łąka',
  'theme.name.dawn-mist': 'Poranna mgła',
  'theme.name.ultraviolet': 'Ultrafiolet',
  'theme.name.rozy-roz': 'Róży róż',
  'theme.name.choco-pumpkin': 'Czekoladowa dynia',
  'theme.name.flame': 'Płomień',
  'theme.name.pizza': 'Pizza, pasta, buona sera',
  'theme.name.matrix': 'Matrix',
  'theme.name.rainbow': 'Tęcza',
  'theme.name.psychedellic': 'Psychedellic',
  'theme.name.ja-nie-wymyslam': 'Ja nie wymyślam',
  'typography.name.neon-circuit': 'Neon circuit',
  'typography.name.chakra-petch': 'Turbo grid',
  'typography.name.solar-grid': 'Solar grid',
  'typography.name.iron-press': 'Iron press',
  'home.title': 'Tysiąc Kości Niezgody',
  'home.newGameShort': 'NOWA GRA',
  'home.recordScores': 'ZAPISUJ WYNIKI',
  'home.scores': 'Wyniki gier',
  'home.guide': 'Przewodnik',
  'home.stats': 'Statystyki',
  'home.account': 'Konto',
  'home.guideHint': 'Zasady',
  'home.statsHint': 'Rzuty',
  'home.accountHint': 'Profil',
  'home.scoresHint': 'Historia',
  'home.scenariosHint': 'Scenariusze',
  'home.newGame': 'Nowa Gra (Resetuj)',
  'home.install': 'Zainstaluj aplikację',
  'home.iosHow': '📲 Jak zainstalować na iOS',
  'home.ios.title': 'Instalacja na iPhone / iPad:',
  'home.ios.step1': 'Otwórz w Safari (wymagane).',
  'home.ios.step2a': 'Stuknij ikonę',
  'home.ios.step2b': '(kwadrat ze strzałką w górę).',
  'home.ios.share': 'Udostępnij',
  'home.ios.step3': 'Wybierz „Dodaj do ekranu początkowego”.',
  'home.ios.step4': 'Potwierdź nazwę i naciśnij „Dodaj”.',
  'home.ios.after': 'Po instalacji uruchamiaj z ikony – aplikacja będzie działać w trybie pełnoekranowym.',
  'header.tilesBar': 'Pasek graczy',
  'header.tileLabel': '{name}, {score} punktów',
  'common.back': 'Powrót',
  'common.backToLobby': 'Wróć do lobby',
  'common.cancel': 'Anuluj',
  'account.title': 'Konto',
  'account.optionalTitle': 'Konto jest opcjonalne.',
  'account.optionalBody': 'Możesz grać anonimowo i zalogować się dopiero wtedy, gdy chcesz odblokować funkcje konta.',
  'account.optionalFeature.stats': 'Prywatne statystyki własnych gier',
  'account.optionalFeature.friends': 'Znajomi i własny kod gracza',
  'account.optionalFeature.invites': 'Zaproszenia do gry i szybki powrót do lobby',
  'account.signInGoogle': 'Zaloguj się przez Google',
  'account.signInApple': 'Zaloguj się przez Apple',
  'account.signingIn': 'Przekierowuję do logowania…',
  'account.signOut': 'Wyloguj się',
  'account.signingOut': 'Wylogowuję…',
  'account.delete.title': 'Usunięcie konta i danych',
  'account.delete.subtitle': 'Tysiąc Kości Niezgody',
  'account.delete.appName': 'Tysiąc Kości Niezgody',
  'account.delete.publicNotice': 'Publiczna strona zgłoszenia usunięcia konta',
  'account.delete.developerLabel': 'Deweloper:',
  'account.delete.developerName': 'Janek Rumianek',
  'account.delete.intro': 'Ta strona służy do zgłoszenia usunięcia konta użytkownika i powiązanych danych dla aplikacji Tysiąc Kości Niezgody. Użyj przycisku poniżej, aby otworzyć gotową wiadomość e-mail do supportu.',
  'account.delete.scopeTitle': 'Zakres usunięcia danych',
  'account.delete.scopeItem1': 'konto użytkownika oraz dane logowania powiązane z aplikacją Tysiąc Kości Niezgody,',
  'account.delete.scopeItem2': 'prywatne wyniki, statystyki, profil gracza, znajomych i zaproszenia powiązane z tym kontem,',
  'account.delete.scopeItem3': 'pozostałe dane konta przechowywane wyłącznie do działania funkcji aplikacji, o ile nie musimy ich zachować z przyczyn prawnych lub bezpieczeństwa.',
  'account.delete.scopeFootnote': 'Po weryfikacji zgłoszenia usunięcie danych jest nieodwracalne.',
  'account.delete.requestHint': 'Poniżej widzisz gotową treść prośby. Jeśli jesteś zalogowany, adres e-mail konta i ID użytkownika są już uzupełnione. Jeśli nie jesteś zalogowany, wpisz adres e-mail używany w koncie aplikacji.',
  'account.delete.requestLabel': 'Treść prośby',
  'account.delete.send': 'Wyślij prośbę e-mailem',
  'account.delete.copy': 'Skopiuj treść prośby',
  'account.delete.copyDone': 'Skopiowano',
  'account.delete.afterSend': 'Po wysłaniu zgłoszenia na dice1k@outlook.com otrzymasz potwierdzenie obsługi na adres e-mail konta lub w odpowiedzi na wiadomość.',
  'account.delete.irreversible': 'Usunięcie danych jest nieodwracalne.',
  'account.delete.loggedOutBody': 'Nie musisz się logować, aby złożyć wniosek. Jeśli otwierasz stronę bez sesji, uzupełnij w treści prośby adres e-mail używany w koncie Tysiąc Kości Niezgody i dodaj identyfikator użytkownika, jeśli go znasz.',
  'account.delete.backHint': 'Nie chcesz usuwać danych?',
  'account.delete.backAction': 'Wróć do konta',
  'account.delete.mail.subject': 'Tysiąc Kości Niezgody - prośba o usunięcie danych konta',
  'account.delete.mail.bodyIntro': 'Proszę o usunięcie mojego konta i powiązanych danych w aplikacji Tysiąc Kości Niezgody.',
  'account.delete.mail.emailLabel': 'E-mail konta',
  'account.delete.mail.emailPlaceholder': '[wpisz adres e-mail konta]',
  'account.delete.mail.userIdLabel': 'Id użytkownika',
  'account.delete.mail.userIdPlaceholder': '[opcjonalnie]',
  'account.delete.mail.detailsLabel': 'Szczegóły',
  'account.friendCode': 'Twój kod',
  'account.friendCodePending': 'Tworzę profil...',
  'account.displayName.placeholder': 'Wpisz nazwę gracza',
  'account.displayName.save': 'Zapisz',
  'account.displayName.saving': 'Zapisuję...',
  'account.displayName.saved': 'Nazwa została zapisana.',
  'account.displayName.length': 'Nazwa musi mieć od {min} do {max} znaków.',
  'account.displayName.invalid': 'Nazwa zawiera niedozwolone znaki.',
  'account.userFallback': 'Gracz',
  'account.error.generic': 'Nie udało się wykonać tej operacji.',
  'account.error.notAuthenticated': 'Ta akcja wymaga zalogowanego konta.',
  'account.error.friendCodeRequired': 'Wpisz poprawny kod znajomego.',
  'account.error.friendNotFound': 'Nie znaleziono znajomego dla podanego kodu.',
  'account.error.cannotAddYourself': 'Nie możesz dodać własnego konta do znajomych.',
  'account.error.cannotInviteYourself': 'Nie możesz wysłać zaproszenia do własnego konta.',
  'account.error.recipientNotFriend': 'Zaproszenia do gry możesz wysyłać tylko do zaakceptowanych znajomych.',
  'account.error.gameGroupNotFound': 'Nie udało się znaleźć aktywnego lobby dla tego zaproszenia.',
  'account.error.recipientProfileNotFound': 'Nie udało się odnaleźć profilu odbiorcy.',
  'account.error.friendRequestNotFound': 'Ta prośba do znajomych nie jest już dostępna.',
  'account.error.gameInviteNotFound': 'To zaproszenie do gry nie jest już dostępne.',
  'account.status.loggedIn': 'Zalogowano',
  'account.status.loggedOut': 'Tryb anonimowy',
  'account.backToAccount': 'Wróć do konta',
  'account.section.results.title': 'Moje wyniki',
  'account.section.stats.title': 'Moje statystyki',
  'account.section.stats.loggedInBody': 'Sekcja prywatnych statystyk korzysta z nowego modelu profilu i partycypacji gier.',
  'account.section.stats.loggedOutBody': 'Po zalogowaniu zobaczysz tutaj prywatne statystyki własnych gier.',
  'account.section.stats.lead': 'W skrócie',
  'account.section.stats.emptyTitle': 'Jeszcze bez rozegranych partii',
  'account.section.stats.emptyBody': 'Gdy zapiszesz pierwszą grę, pojawi się tutaj bardziej żywy pulpit Twoich statystyk.',
  'account.section.stats.group.results.title': 'Wyniki',
  'account.section.stats.group.results.subtitle': 'Sposób kończenia gier i poziom osiąganych wyników.',
  'account.section.stats.group.tempo.title': 'Tempo',
  'account.section.stats.group.tempo.subtitle': 'Rytm gry, siła tur i ostatnia aktywność.',
  'account.section.stats.group.turnProfile.title': 'Profil tur',
  'account.section.stats.group.turnProfile.subtitle': 'Balans pomiędzy dobrymi, pustymi i kosztownymi turami.',
  'account.section.stats.group.risk.title': 'Ryzyko',
  'account.section.stats.group.risk.subtitle': 'Miejsca, w których gra najbardziej gryzie albo daje po łapach.',
  'account.section.stats.group.patterns.title': 'Układy i tryby',
  'account.section.stats.group.patterns.subtitle': 'Strity, wielokrotności i rozkład gier online vs real.',
  'account.section.friends.title': 'Znajomi',
  'account.section.social.title': 'Znajomi i zaproszenia',
  'account.section.friends.loggedOutBody': 'Po zalogowaniu będziesz mógł dodawać znajomych po kodzie lub linku.',
  'account.friends.copyAction': 'Kopiuj kod',
  'account.friends.copyDone': 'Skopiowano kod',
  'account.friends.copyError': 'Nie udało się skopiować Twojego kodu.',
  'account.friends.shareAction': 'Udostępnij kod',
  'account.friends.shareDone': 'Skopiowano link',
  'account.friends.shareError': 'Nie udało się udostępnić kodu znajomego.',
  'account.friends.shareText': 'Dodaj mnie do znajomych w Dice1k. Mój kod: {code}',
  'account.friends.form.label': 'Dodaj znajomego używając kodu',
  'account.friends.form.placeholder': 'Wpisz kod',
  'account.friends.form.submit': 'Wyślij prośbę',
  'account.friends.form.submitting': 'Wysyłam...',
  'account.friends.form.required': 'Wpisz kod znajomego, zanim wyślesz prośbę.',
  'account.friends.incomingTitle': 'Przychodzące',
  'account.friends.outgoingTitle': 'Wysłane',
  'account.friends.profile': 'Profil',
  'account.friends.remove': 'Usuń',
  'account.friends.removeConfirm': 'Usunąć znajomego: {name}?',
  'account.friends.emptyIncoming': 'Brak oczekujących próśb przychodzących.',
  'account.friends.emptyOutgoing': 'Brak oczekujących próśb po Twojej stronie.',
  'account.friends.emptyFriends': 'Nie masz jeszcze zaakceptowanych znajomości.',
  'account.friends.accept': 'Akceptuj',
  'account.friends.reject': 'Odrzuć',
  'account.friends.cancel': 'Cofnij',
  'account.friends.status.pending': 'Oczekuje',
  'account.friends.status.accepted': 'Zaakceptowano',
  'account.friends.status.rejected': 'Odrzucono',
  'account.friends.status.cancelled': 'Cofnięto',
  'account.friends.notice.requestSent': 'Wysłano prośbę do: {name}.',
  'account.friends.notice.alreadyFriends': 'Masz już znajomość z: {name}.',
  'account.friends.notice.alreadyPending': 'Prośba do {name} już czeka na odpowiedź.',
  'account.friends.notice.incomingPending': '{name} już wysłał Ci prośbę. Wejdź w przychodzące i zaakceptuj ją.',
  'account.friends.notice.newIncoming': 'Masz nową prośbę do znajomych.',
  'account.friends.notice.requestAccepted': 'Prośba została zaakceptowana. Relacja znajomości jest aktywna.',
  'account.friends.notice.requestRejected': 'Prośba została odrzucona.',
  'account.friends.notice.requestCancelled': 'Wysłana prośba została cofnięta.',
  'account.friends.notice.removed': 'Znajomy został usunięty.',
  'account.friends.notice.generic': 'Operacja na znajomych zakończona.',
  'account.friends.stats.games': 'Gry',
  'account.friends.stats.wins': 'Wygrane',
  'account.friends.stats.losses': 'Przegrane',
  'account.friendStats.title': 'Statystyki gracza',
  'account.friendStats.emptyTitle': 'Jeszcze bez rozegranych partii',
  'account.friendStats.emptyBody': 'Ten gracz nie ma jeszcze zapisanych gier na tym profilu.',
  'account.section.invites.title': 'Zaproszenia',
  'account.invites.incomingTitle': 'Zaproszenia',
  'account.invites.outgoingTitle': 'Wysłane',
  'account.invites.emptyIncoming': 'Brak przychodzących zaproszeń do gier.',
  'account.invites.emptyOutgoing': 'Nie wysłałeś jeszcze zaproszeń do gry.',
  'account.invites.accept': 'Dołącz',
  'account.invites.decline': 'Usuń',
  'account.invites.cancel': 'Anuluj',
  'account.invites.openLobby': 'Otwórz lobby',
  'account.invites.status.pending': 'Oczekuje',
  'account.invites.status.accepted': 'Przyjęte',
  'account.invites.status.declined': 'Odrzucone',
  'account.invites.status.expired': 'Wygasłe',
  'account.invites.status.cancelled': 'Anulowane',
  'account.invites.notice.newIncoming': 'Masz nowe zaproszenie do gry.',
  'account.invites.notice.accepted': 'Zaproszenie przyjęte. Otwieram lobby gry.',
  'account.invites.notice.declined': 'Zaproszenie do gry zostało odrzucone.',
  'account.invites.notice.cancelled': 'Zaproszenie do gry zostało anulowane.',
  'online.invites.title': 'Zaproś znajomych',
  'online.invites.sendAction': 'Zaproś',
  'online.invites.sending': 'Wysyłam...',
  'online.invites.notice.sent': 'Zaproszenie do gry wysłane do: {name}.',
  'online.invites.notice.alreadyPending': 'Dla {name} jest już aktywne oczekujące zaproszenie.',
  'online.invites.notice.sentWithoutPush': 'Zaproszenie do gry utworzono dla: {name}. Powiadomienie push nie zostało dostarczone.',
  'online.invites.notice.sentPushFailed': 'Zaproszenie do gry utworzono dla: {name}, ale wysyłka powiadomienia push się nie udała.',
  'online.invites.notice.accepted': '{name} zaakceptował zaproszenie.',
  'online.invites.notice.declined': '{name} odrzucił zaproszenie.',
  'online.invites.notice.expired': 'Zaproszenie dla {name} wygasło.',
  'online.invites.notice.cancelled': 'Zaproszenie dla {name} nie jest już aktywne.',
  'online.invites.entry.checking': 'Sprawdzam status zaproszenia...',
  'online.invites.entry.openAccount': 'Przejdź do konta',
  'online.invites.entry.authRequired': 'To zaproszenie wymaga zalogowanego konta.',
  'online.invites.entry.authRequiredDetail': 'Zaloguj się, aby kontynuować z tym zaproszeniem.',
  'online.invites.entry.pending': 'Otwieram zaproszenie...',
  'online.invites.entry.pendingDetail': 'Aplikacja akceptuje zaproszenie i przygotowuje właściwe lobby.',
  'online.invites.entry.invalid': 'Tego zaproszenia nie można już otworzyć.',
  'online.invites.entry.invalidDetail': 'Link jest nieprawidłowy albo zaproszenie nie należy do tego konta.',
  'online.invites.entry.lookupFailed': 'Nie udało się sprawdzić statusu zaproszenia.',
  'online.invites.entry.expired': 'To zaproszenie wygasło.',
  'online.invites.entry.declined': 'To zaproszenie zostało już odrzucone.',
  'online.invites.entry.cancelled': 'To zaproszenie zostało anulowane.',
  'online.invites.entry.inactiveDetail': 'Wróć do konta i wybierz inne aktywne zaproszenie lub poproś hosta o nowe.',
  'account.metrics.games': 'Gry',
  'account.metrics.wins': 'Wygrane',
  'account.metrics.winRate': 'Win rate',
  'account.metrics.avgPlace': 'Średnie miejsce',
  'account.metrics.avgFinalScore': 'Średni wynik',
  'account.metrics.bestPositivePoints': 'Najlepsze pkt. dodatnie',
  'account.metrics.maxTurn': 'Najwyższa tura',
  'account.metrics.avgTurnPoints': 'Średnio na turę',
  'account.metrics.totalTurns': 'Suma tur',
  'account.metrics.positiveTurns': 'Tury dodatnie',
  'account.metrics.zeroTurns': 'Tury zerowe',
  'account.metrics.negativeTurns': 'Tury ujemne',
  'account.metrics.totalPositivePoints': 'Punkty dodatnie',
  'account.metrics.totalNegativePoints': 'Punkty ujemne',
  'account.metrics.totalOvertakes': 'Wyprzedzenia',
  'account.metrics.longestPositiveStreak': 'Seria z punktami',
  'account.metrics.longestNonPositiveStreak': 'Seria bez punktów',
  'account.metrics.firstRollBusts': 'Busty w pierwszym rzucie',
  'account.metrics.overThousandBusts': 'Busty powyżej 1000',
  'account.metrics.missedStraights': 'Zmarnowane strity',
  'account.metrics.smallStraights': 'Strity 1-5',
  'account.metrics.largeStraights': 'Strity 2-6',
  'account.metrics.totalStraights': 'Wszystkie strity',
  'account.metrics.exactTriples': 'Trójki',
  'account.metrics.exactQuads': 'Czwórki',
  'account.metrics.exactQuints': 'Piątki',
  'account.metrics.onlineGames': 'Gry online',
  'account.metrics.realGames': 'Gry real',
  'account.metrics.lastPlayedAt': 'Ostatnia gra',
  'auth.callback.title': 'Logowanie',
  'auth.callback.subtitle': 'Kończę logowanie i przywracam sesję konta',
  'auth.callback.loading': 'Trwa finalizacja logowania…',
  'auth.callback.success': 'Logowanie zakończone. Przekierowuję dalej…',
  'auth.callback.error': 'Nie udało się sfinalizować logowania.',
  'auth.callback.backToAccount': 'Wróć do konta',
  'join.enterIdTitle': 'Wprowadź ID Gry',
  'join.enterIdHelp.online': 'Pobierz ID gry od hosta i wpisz swoje imię',
  'join.enterIdHelp.real': 'Pobierz ID gry od gospodarza',
  'join.enterNameTitle': 'Podaj swoje imię',
  'join.enterNameHelp': 'Mamy już ID gry z linku — wpisz tylko imię, aby dołączyć.',
  'join.mode.online': 'Gra Online',
  'join.mode.real': 'Gra w Realu',
  'join.gameIdLabel': 'ID Gry',
  'join.gameIdPlaceholder': 'Wprowadź ID gry...',
  'join.nameLabel': 'Twoje imię (online)',
  'join.namePlaceholder': 'Wprowadź imię (2-20 znaków)',
  'join.cta.joining': 'Dołączam...',
  'join.cta.join': 'Dołącz do Gry',
  'join.viewerHint': 'Jeśli gra już trwa, dołączysz jako widz. Host może uruchomić kolejną rundę w tym samym pokoju, aby odświeżyć skład.',
  'join.howTitle': 'Jak dołączyć:',
  'join.stepsOnline.1': 'Poproś gospodarza o ID lobby online lub link do gry',
  'join.stepsOnline.2': 'Wpisz ID i swoje imię (2-20 znaków)',
  'join.stepsOnline.3': 'Dołączysz do lobby i po losowaniu kolejności graczy rozpocznie się gra',
  'join.stepsReal.1': 'Poproś gospodarza o ID gry lub link do gry',
  'join.stepsReal.2': 'Wprowadź ID powyżej',
  'join.stepsReal.3': 'Zobaczysz aktualny przebieg gry',
  'join.stepsReal.4': 'Tylko prowadzący może wpisywać wyniki',
  'join.error.idRequired': 'Proszę wprowadzić ID gry',
  'join.error.nameRequired': 'Wprowadź imię (2-20 znaków)',
  'join.error.notFound': 'Gra nie znaleziona lub nieprawidłowe ID gry',
  'join.error.onlineJoin': 'Nie udało się dołączyć do gry online',
  'join.error.generic': 'Dołączenie nie powiodło się',
  'join.error.groupResolve': 'Nie udało się znaleźć aktywnej gry dla tej grupy',
  'join.groupResolving': 'Sprawdzam ostatnią grę grupy...',
  'join.groupResolved': 'Znaleziono grupę – ostatnia gra: {gameId}',
  'add.hostNameLabel': 'Twoje imię (Host)',
  'add.hostNamePlaceholder': 'Wprowadź swoje imię',
  'setup.start': 'Rozpocznij Grę',
  'game.wait.title': 'Tryb Gracza',
  'game.wait.message': 'Oczekiwanie na rozpoczęcie gry lub ponowne łączenie...',
  'game.wait.gameId': 'ID Gry: {gameId}',
  'game.floatingId': 'ID Gry',
  'game.focus.turnNumber': 'Aktualna tura: {turn}',
  'game.focus.scoreLabel': 'Wynik',
  'game.focus.remainingLabel': 'Pozostało',
  'game.recentEvents.kicker': 'Ostatnie wpisy',
  'game.recentEvents.score': 'Zapis punktów',
  'game.recentEvents.penalty': 'Kara',
  'game.recentEvents.overtake': 'Wyprzedzenie',
  'game.actionSummary.title': 'Bieżąca sytuacja',
  'game.actionSummary.turnLabel': 'Tura',
  'game.actionSummary.rollLabel': 'Rzut',
  'game.actionSummary.leaderLabel': 'Lider',
  'online.title': 'Gra Online',
  'real.title': 'Zapisywanie wyników',
  'real.subtitle': 'Dodaj graczy, ustaw kolejność i rozpocznij grę',
  'real.addPlayerTitle': 'Imię gracza',
  'real.addPlayerPlaceholder': 'Wpisz imię gracza',
  'real.addPlayerCta': 'Dodaj gracza',
  'real.orderHint': 'Przeciągnij, aby ustawić kolejność',
  'real.selfHint': 'Opcjonalnie zaznacz siebie, aby po grze zapisać prywatne statystyki na koncie.',
  'real.selfAction': 'To ja',
  'real.selfSelected': 'JA',
  'online.share': 'Udostępnij link gry:',
  'online.shareFriendsTitle': 'Zaproś znajomych linkiem',
  'online.shareCtaTitle': 'Teraz udostępnij grę innym graczom',
  'online.shareCtaAction': 'Udostępnij link',
  'online.lastGameTitle': 'Ostatnia gra zakończona',
  'online.lastGameSubtitle': 'Ostatnia runda zakończona. Ustalcie skład kolejnej rundy w tym samym pokoju.',
  'online.lastGameHint': 'Najpierw widać skład kolejnej rundy, a końcowe rankingi są poniżej.',
  'online.showResults': 'Pokaż końcowe rankingi',
  'online.startNextGame': 'Rozpocznij kolejną rundę',
  'online.waitForHostNext': 'Skład kolejnej rundy aktualizuje się na bieżąco poniżej.',
  'online.postGame.rosterTitle': 'Skład kolejnej rundy',
  'online.postGame.rosterHint': 'Wszyscy od razu widzą, kto zgłosił udział w kolejnej rundzie jako gracz.',
  'online.postGame.hostBadge': 'Host',
  'online.postGame.rolePlayer': 'Poprzednia rola: gracz',
  'online.postGame.roleViewer': 'Poprzednia rola: widz',
  'online.postGame.statusPlayerReady': 'Potwierdzony na kolejną rundę',
  'online.postGame.statusPlayerPending': 'Nie zgłosił udziału w kolejnej rundzie',
  'online.postGame.statusViewerJoining': 'Dołączy do kolejnej rundy jako gracz',
  'online.postGame.statusViewerStaying': 'Nie dołącza do kolejnej rundy jako gracz',
  'online.postGame.statusBotReady': 'Bot w kolejnej rundzie',
  'online.postGame.resultsTitle': 'Końcowe rankingi',
  'home.resumeOnlineTitle': 'Masz niedokończoną grę online',
  'home.resumeOnlineHint': 'Możesz wrócić do aktywnej rozgrywki albo zostać na ekranie startowym.',
  'home.resumeOnlineAction': 'Wznów grę',
  'home.resumeOnlineDismiss': 'Nie teraz',
  'online.joinTitle': 'Dołącz do lobby',
  'online.joinCta': 'Dołącz',
  'online.error.nextGame': 'Nie udało się uruchomić kolejnej rundy.',
  'online.createGame': 'Stwórz grę',
  'online.copied': 'Skopiowano!',
  'settings.gameLinkLabel': 'Link gry',
  'settings.gameLinkCopy': 'Udostępnij link gry',
  'settings.gameLinkCopied': 'Skopiowano!',
  'online.error.nameTaken': 'Ta nazwa jest już zajęta',
  'online.error.addPlayer': 'Nie udało się dodać gracza.',
  'online.error.group': 'Nie udało się przygotować pokoju grupowego. Utworzyliśmy nową lokalną sesję.',
  'online.groupSyncPending': 'Pokój jest już gotowy. Synchronizujemy link i metadane grupy w tle.',
  'online.groupSyncFailed': 'Pokój działa, ale nie udało się jeszcze zsynchronizować metadanych grupy.',
  'online.waitingMessage': 'Zaczekaj, aż host uruchomi grę.',
  'online.lobbySubtitle': 'Graj online z innymi graczami i botami.',
  'online.exitConfirm': 'Na pewno chcesz opuścić lobby i wrócić na stronę główną?',
  'online.hostSubtitle': 'Graj online z innymi graczami i botami.',
  'online.players': 'Gracze',
  'online.you': 'TY',
  'online.ready.saving': 'Zapisywanie...',
  'online.ready.toggleSelf': 'Przełącz swoją gotowość',
  'online.ready.ready': 'GOTOWY',
  'online.ready.waiting': 'OCZEKUJE',
  'online.bot.tag': 'BOT',
  'online.bots.title': 'Dodaj bota',
  'online.bots.profile.conservative': 'Asekuro',
  'online.bots.profile.balanced': 'Neutralo',
  'online.bots.profile.risky': 'Ryzykanto',
  'online.bots.variant.conservative': '🛡️ Asekuro',
  'online.bots.variant.balanced': '⚖️ Neutralo',
  'online.bots.variant.risky': '🎲 Ryzykanto',
  'online.bots.adding': 'Dodawanie...',
  'online.bots.remove': 'Usuń',
  'online.bots.removing': 'Usuwanie...',
  'online.noPlayers': 'Brak graczy',
  'online.settingsTitle': 'Ustawienia gry',
  'online.settingsHostNote': 'Ustawiane przez hosta',
  'online.rapid.title': 'Tryb rapid',
  'online.rapid.enabled': 'Włączony',
  'online.rapid.freeThreshold': 'Pierwszy interwał',
  'online.rapid.baseBlock': 'Bazowy blok kary',
  'online.rapid.minBlock': 'Minimalny blok kary',
  'online.rapid.scalingMode': 'Tryb skalowania',
  'online.rapid.scaling.none': 'Stały',
  'online.rapid.scaling.player-score': 'Wynik gracza',
  'online.rapid.scaling.turn-number': 'Numer tury',
  'online.rapid.scaling.leader-score': 'Wynik lidera',
  'online.rapid.summary': 'Rapid: darmowy czas {threshold}, blok {block}, minimum {min}, tryb {mode}.',
  'online.tunnelsLabel': 'Tunele',
  'online.tunnelsHint': 'Strefy przejścia 200-300 i 700-800',
  'online.rescueLabel': 'Ratowanie przez 5',
  'online.rescueHint': 'Suma kostek ÷ 5 = dodatkowy rzut',
  'online.zonesLabel': 'Strefy',
  'online.zonesHint': 'Ukryte strefy premii i kar na trasie; odkrywają się po pierwszym trafieniu',
  'online.zonesAvoidTunnelsLabel': 'Strefy poza tunelami',
  'online.zonesAvoidTunnelsHint': 'Nie losuj stref wewnątrz 200-300 i 700-800',
  'online.devSpectatorLabel': 'Play as Spectator (DEV)',
  'online.devSpectatorHint': 'Twoje tury kończą się natychmiast z 0 punktów.',
  'online.devSpectatorAria': 'Przełącz Play as Spectator w trybie dev',
  'online.devZeroDelayLabel': 'Zero Opóźnienia (DEV)',
  'online.devZeroDelayHint': 'Boty wykonują akcje natychmiast, bez czekania.',
  'online.devZeroDelayAria': 'Przełącz zero opóźnienia botów w trybie dev',
  'online.spectators': 'Widzowie',
  'online.restarting': 'Przygotowywanie kolejnej rundy…',
  'online.shuffle': 'Losuj kolejność',
  'online.waitAll': 'Czekam na gotowość wszystkich',
  'online.startGame': 'Rozpocznij grę',
  'host.restore.title': 'Przywracanie gry',
  'host.restore.message': 'Odtwarzam stan gry z eventów{ellipsis}',
  'host.restore.gameId': 'ID Gry: {gameId}',
  'host.restore.retry': 'Spróbuj ponownie',
  'order.dialogLabel': 'Wylosowana kolejność graczy',
  'order.title': 'Wylosowana kolejność',
  'order.begin': 'Rozpocznij grę',
  'order.wait': 'Oczekiwanie na start hosta…',
  'playerList.left': 'opuścił grę',
  'scoreEntry.formLabel': 'Wpis wyniku',
  'scoreEntry.currentPlayer': 'Aktualny gracz',
  'scoreEntry.confirm': 'Potwierdź',
  'scoreEntry.save': 'Zapisz',
  'scoreEntry.saveSr': 'Zapisz wynik',
  'scoreEntry.quickAria': 'Dodaj {value}',
  'scoreEntry.undo': 'Cofnij',
  'scoreEntry.undoSr': 'Cofnij ostatni',
  'scoreEntry.history.show': 'Pokaż Historię',
  'scoreEntry.history.hide': 'Ukryj Historię',
  'playerList.aria': 'Lista graczy',
  'playerList.title': 'Widok Graczy',
  'playerList.remaining': 'Pozostało: {points}',
  'playerList.tunnelExit200': 'Wyjście z tunelu: {need}',
  'playerList.tunnelExit700': 'Wyjście z tunelu: {need}',
  'playerList.lastTurn': 'Ostatnia tura',
  'playerList.stats.avg': 'Średnia',
  'playerList.stats.overtakes': 'Wyprzedzenia',
  'playerList.stats.busts': 'Fury',
  'playerList.stats.penalties': 'Kary',
  'playerList.tags.rule3dice': 'zasada 3 kości',
  'playerList.reason.firstZero': 'kara za furę w pierwszym rzucie',
  'playerList.reason.rapidTime': 'kara za rapid',
  'playerList.reason.zoneBonus': 'premia ze strefy',
  'playerList.reason.zonePenalty': 'kara ze strefy',
  'playerList.reason.and': 'oraz',
  'playerList.lastTurn.roll': 'z rzutu',
  'playerList.firstEntryPrompt': 'Rzuć minimum 50 punktów',
  'playerList.overtake.label': 'za wyprzedzenie',
  'die.unrolled': 'Kość nie została jeszcze rzucona',
  'die.value': 'Kość: {value}{kept}',
  'die.kept': ' (zatrzymana)',
  'history.title': 'Historia Gry',
  'history.close': 'Zamknij historię',
  'history.empty': 'Brak ruchów',
  'history.overtake': 'Wyprzedził: {victims}',
  'history.turnAt': 'Tura {turn} • {time}',
  'history.pointsSuffix': 'pkt',
  'history.zone.kind.bonus': 'premia',
  'history.zone.kind.penalty': 'kara',
  'history.zone.step': 'Strefa {start}-{end} ({kind} {delta}): {from} → {to}',
  'history.zone.overtake': 'Wyprzedzenie ({victims}): {bonus} → {to}',
  'history.zone.overtakeAnonymous': 'Wyprzedzenie ({count}): {bonus} → {to}',
  'history.zone.voidedPrefix': '[pętla] ',
  'history.zone.loop': 'Pętla stref – gracz zatrzymany na najgorszym kroku: {score}',
  'rapid.progress.freeStage': 'Pierwsze -5 pkt',
  'rapid.progress.penaltyStage': 'Następne -5 pkt',
  'scores.title': 'Wyniki gier',
  'scores.subtitle': 'Podsumowanie ostatnich sesji',
  'scores.privateTitle': 'Twoje gry',
  'scores.privateSubtitle': 'Tu znajdziesz szczegóły wszystkich swoich gier.',
  'scores.privateLoggedOutBody': 'Ta sekcja jest dostępna tylko po zalogowaniu.',
  'scores.privateEmpty': 'Nie masz jeszcze zapisanych gier na swoim koncie.',
  'scores.loading': 'Ładowanie wyników…',
  'scores.empty': 'Brak danych',
  'scores.emptyRecent': 'Brak danych gier w ostatnim czasie.',
  'scores.prev': 'Poprzednia',
  'scores.next': 'Następna',
  'scores.page': 'Strona {page}',
  'scores.deleteHint': 'Operacje usuwania dostępne tylko lokalnie w trybie deweloperskim.',
  'scores.deleteGameAction': 'Usuń grę',
  'scores.deleteSessionAction': 'Usuń sesję',
  'scores.deletePending': 'Usuwanie…',
  'scores.deleteGameError': 'Nie udało się usunąć tej gry.',
  'scores.deleteSessionError': 'Nie udało się usunąć tej sesji.',
  'scores.table.rank': '#',
  'scores.table.player': 'Gracz',
  'scores.table.score': 'Wynik',
  'scores.table.posPoints': '+ pkt',
  'scores.table.negPoints': '- pkt',
  'scores.table.posTurns': '+ tury',
  'scores.table.zeroTurns': '0 tury',
  'scores.table.negTurns': '- tury',
  'scores.table.turnMix': 'Mix tur',
  'scores.table.busts': 'Fury',
  'scores.table.missedStraights': 'Strity bez punktów',
  'scores.table.maxTurn': 'Max tura',
  'scores.session.label': 'Sesja',
  'scores.session.games': 'Gier',
  'scores.session.wins': 'Wygrane',
  'scores.session.avgPlace': 'Śr. miejsce',
  'scores.session.histogram': 'Histogram miejsc',
  'scores.session.totalPoints': 'Suma punktów',
  'stats.title': 'Statystyki kości',
  'stats.subtitle': 'Agregowane raz dziennie statystyki wszystkich gier.',
  'stats.refreshedAt': 'Ostatnie przeliczenie: {timestamp}',
  'stats.error': 'Nie udało się wczytać statystyk',
  'stats.noData': 'Brak danych do wyświetlenia.',
  'stats.rollEvents': 'Zarejestrowane rzuty',
  'stats.totalDice': 'Wyrzuconych kości',
  'stats.faces.title': 'Rozkład wartości (1–6)',
  'stats.faces.subtitle': 'Liczba wystąpień i udział procentowy',
  'stats.faces.name1': 'Jedynka',
  'stats.faces.name2': 'Dwójka',
  'stats.faces.name3': 'Trójka',
  'stats.faces.name4': 'Czwórka',
  'stats.faces.name5': 'Piątka',
  'stats.faces.name6': 'Szóstka',
  'stats.positions.title': 'Kości na pozycjach 1–5',
  'stats.positions.subtitle': 'Które wartości dominują na poszczególnych slotach',
  'stats.positions.positionPrefix': 'Pozycja',
  'stats.triples.title': 'Trójki, czwórki i piątki',
  'stats.triples.subtitle': 'Liczone są tylko układy wyrzucone w pojedynczym rzucie, osobno dla każdej wartości kości.',
  'stats.triples.kindThree': 'Trzy kości',
  'stats.triples.kindFour': 'Cztery kości',
  'stats.triples.kindFive': 'Pięć kości',
  'stats.straights.title': 'Strity',
  'stats.straights.subtitle': 'Liczone są wszystkie strity — te zauważone i nie.',
  'stats.theory.triplets.title': 'Porównanie z teorią',
  'stats.theory.triplets.subtitle': 'Porównujemy częstość układów z matematyczną szansą, ale tylko gdy zapisaliśmy rozmiar rzutu.',
  'stats.theory.observed': 'Wypadło',
  'stats.theory.theoretical': 'Teoria',
  'stats.theory.difference': 'Różnica',
  'stats.theory.sample': 'Próba',
  'stats.gameLength.title': 'Długość gier (tury)',
  'stats.gameLength.subtitle': 'Rozkład liczby tur dla zakończonych gier.',
  'stats.gameLength.games': 'Gry',
  'stats.gameLength.avg': 'Średnia',
  'stats.gameLength.min': 'Minimum',
  'stats.gameLength.max': 'Maksimum',
  'stats.gameLength.total': 'Suma tur',
  'stats.bots.title': 'Skuteczność botów',
  'stats.bots.profiles': 'Profile botów',
  'stats.bots.subtitle': 'Ranking profili botów na podstawie wyników zakończonych gier, z miejscem znormalizowanym do liczby graczy.',
  'stats.bots.best': 'Najlepszy bot',
  'stats.bots.worst': 'Najsłabszy bot',
  'stats.bots.none': 'Brak danych',
  'stats.bots.appearances': 'Wystąpienia',
  'stats.bots.games': 'Gry',
  'stats.bots.wins': 'Wygrane',
  'stats.bots.winRate': 'Winrate',
  'stats.bots.relativePlace': 'Względne miejsce',
  'stats.bots.avgPlace': 'Śr. miejsce',
  'stats.bots.avgScore': 'Śr. końcowy wynik',
  'stats.rollsLabel': 'rzutów',
  'results.title': 'Wyniki gry',
  'results.subtitle': 'Szczegółowe statystyki dla gry {id}',
  'results.loading': 'Ładowanie danych gry…',
  'results.error': 'Nie udało się wczytać tej gry.',
  'results.noEvents': 'Brak zapisanych zdarzeń dla tej gry.',
  'results.deleteAction': 'Usuń grę testową',
  'results.deletePending': 'Usuwanie…',
  'results.deleteConfirm': 'Usunąć grę {id} oraz wszystkie powiązane dane? Tego nie da się cofnąć.',
  'results.deleteHint': 'Widoczne tylko na serwerze deweloperskim.',
  'results.deleteError': 'Nie udało się usunąć tej gry.',
  'results.metricsTitle': 'Metryki graczy',
  'results.metricsHeader': 'Metryka',
  'results.metric.avg.desc': 'Średnia punktów na turę.',
  'results.metric.avgPositive.desc': 'Średnia punktów w turach punktowanych.',
  'results.metric.maxTurn.desc': 'Najlepszy wynik pojedynczej tury.',
  'results.metric.totalPositive.desc': 'Suma punktów dodatnich.',
  'results.metric.penalties.desc': 'Tury zakończone ujemnym wynikiem.',
  'results.metric.overtakePenalties.desc': 'Punkty stracone z powodu wyprzedzeń.',
  'results.metric.zerosNeg.desc': 'Tury zakończone zerem lub minusem.',
  'results.metric.streakPos.desc': 'Najdłuższa dodatnia seria.',
  'results.metric.streakNonPos.desc': 'Najdłuższa seria bez punktów.',
  'results.metric.firstEntry.desc': 'Tura pierwszego wejścia 50+.',
  'results.metric.stdDev.desc': 'Zmienność punktów na turę (mniej = stabilniej).',
  'results.metric.pointsShare.desc': 'Udział w łącznej puli punktów dodatnich.',
  'results.metric.firstRollBusts.desc': 'Fury w pierwszym rzucie.',
  'results.metric.overThousandBusts.desc': 'Przestrzelone 1000.',
  'results.metric.missedStraights.desc': 'Strity ogółem/pominięte.',
  'error.title': 'Coś poszło nie tak',
  'error.message': 'Wystąpił błąd w grze. Odśwież stronę, aby spróbować ponownie.',
  'error.refresh': 'Odśwież stronę',
  'guide.title': 'Przewodnik',
  'guide.subtitle': 'Obsługa aplikacji i zasady gry w jednym miejscu.',
  'guide.about.title': 'O co chodzi w tej grze',
  'guide.about.p1': 'Tysiąc Kości Niezgody to gra typu push-your-luck: w swojej turze rzucasz, zatrzymujesz punktujące kości i decydujesz, czy ryzykować kolejny rzut, czy zapisać (zbankować) wynik.',
  'guide.about.p2': 'Celem jest zdobycie dokładnie 1000 punktów. Wyprzedzenia, tunele i kary potrafią przyspieszyć lub zatrzymać grę.',
  'guide.rules.title': 'Zasady gry',
  'guide.rules.scoringTitle': 'Zasady i punktacja',
  'guide.rules.p1': 'Zaczynając turę rzucasz pięcioma kośćmi i sprawdzasz, które punktują. Zawsze punktują jedynki (10 pkt) oraz piątki (5 pkt) oraz zestawy co najmniej trzech identycznych kości wyrzuconych w jednym rzucie. Przykładowo wyrzucone w jednym rzucie 1, 1, 1, 5, 5 to 110 punktów (100 za trzy jedynki i po 5 za każdą piątkę).',
  'guide.rules.p2': 'Zestawy: trzy jedynki = 100 pkt, cztery = 200, pięć = 400. Dla pozostałych wartości: 3×X = 10×X pkt, 4×X = 20×X pkt, 5×X = 40×X pkt.',
  'guide.rules.table': '3×1 = 100, 4×1 = 200, 5×1 = 400\n3×2 = 20, 4×2 = 40, 5×2 = 80\n3×3 = 30, 4×3 = 60, 5×3 = 120\n3×4 = 40, 4×4 = 80, 5×4 = 160\n3×5 = 50, 4×5 = 100, 5×5 = 200\n3×6 = 60, 4×6 = 120, 5×6 = 240',
  'guide.rules.p3': 'Podobnie do Chińczyka trzeba spełnić warunek wejścia do gry: pierwsze zapisanie wyniku wymaga minimum 50 punktów. Warunkiem zapisu punktów jest to, by „na stole” były co najmniej trzy kości punktujące. Po każdym rzucie musisz zostawić na stole przynajmniej jedną punktującą kość, aby ponownie rzucić pozostałymi. Jeżeli dojdziesz do momentu, że wszystkie pięć kości na stole punktuje, wtedy możesz, ale nie musisz, rzucić ponownie wszystkimi kośćmi. W dowolnym momencie możesz zapisać wynik i zakończyć turę, pod warunkiem że punktują co najmniej trzy kości i w ostatnim Twoim rzucie nie ma fury. Wyjątkiem są tunele (200–300 i 700–800) oraz bezpieczna strefa (od 900).',
  'guide.rules.p4': 'Brak punktujących kości w rzucie to fura: wtedy cała tura daje 0 punktów, a fura w pierwszym rzucie oznacza dodatkową karę −50 punktów. Poniżej 900 pkt do zapisu potrzebujesz minimum trzech punktujących kości.',
  'guide.overtake.overtakeTitle': 'Wyprzedzenia',
  'guide.overtake.overtakeBody': 'Wyprzedzenie innego gracza po zapisaniu punktów daje +50 pkt wyprzedzającemu, a wyprzedzony traci 50. To się dzieje, gdy po zapisaniu punktów przekroczysz wynik innego gracza. Jeśli inny gracz przekroczy Twój wynik, wtedy Ty tracisz 50 pkt, a on zyskuje 50 pkt. Premie za wyprzedzenia mogą się zdarzyć tylko do 900 punktów. W bezpiecznej strefie (900+), nie ma ani kar, ani premii, ale wyprzedać można bez przeszkód.',
  'guide.overtake.tunnelsTitle': 'Tunele',
  'guide.overtake.tunnelsBody': 'Tunele to zakresy 200–300 i 700–800 (włącznie). Jeśli trafisz do tunelu (zatrzymasz się na wyniku od 200 do 300 lub od 700 do 800 punktów) to w kolejnej turze musisz osiągnąć wynik, którym osiągniesz co najmniej koniec tunelu. Jeśli nie przekroczysz jego górnej granicy, wtedy zostajesz na tym samym wyniku. Jeśli przekroczysz górną granicę tunelu, wtedy wychodzisz z niego i możesz normalnie grać dalej.',
  'guide.overtake.safeEndTitle': 'Bezpieczna strefa i koniec gry',
  'guide.overtake.safeEndBody': 'Bezpieczna strefa zaczyna się od 900 punktów. Gracz nie dostaje już w tej strefie kary będąc wyprzedzonym, ani nie dostaje premii gdy wyprzedza. Dodatkowo może zapisywać nawet jedną punktującą kość, limit 3 kości już nie obowiązuje. Nie ma też kary za furę w pierwszym rzucie. Wygrywasz tylko wtedy gdy wyrzucisz wynik, który po zapisie da Ci dokładnie 1000 — przekroczenie 1000 kasuje punkty z tury.',
  'guide.zones.title': 'Strefy',
  'guide.zones.intro': 'Strefy to opcja, którą host włącza w ustawieniach gry — działa tak samo w trybie REAL i ONLINE. Po jej włączeniu na trasie leży sześć ukrytych odcinków: trzy premiowe i trzy karne. Nikt nie wie, gdzie są. Strefa odkrywa się dopiero wtedy, gdy ktoś na niej stanie, i od tej chwili widzą ją wszyscy do końca gry.',
  'guide.zones.ladderBody': 'Losowane jest wyłącznie położenie stref. Siła i szerokość są stałe, według drabinki: im mocniejszy efekt, tym węższa, a więc trudniejsza do trafienia strefa.',
  'guide.zones.table': 'Poziom I: ±60 pkt, szerokość 5 — 2 trafialne wyniki\nPoziom II: ±40 pkt, szerokość 10 — 3 trafialne wyniki\nPoziom III: ±20 pkt, szerokość 15 — 4 trafialne wyniki',
  'guide.zones.placementBody': 'Strefy mieszczą się między 100 a 895 punktem, więc nigdy nie sięgają bezpiecznej strefy, i dzieli je co najmniej 25 punktów przerwy. Osobna opcja „Strefy poza tunelami” trzyma je dodatkowo z dala od zakresów 200–300 i 700–800.',
  'guide.zones.triggerTitle': 'Kiedy strefa działa',
  'guide.zones.triggerBody': 'Strefa działa wtedy i tylko wtedy, gdy Twój znacznik na niej stanie. Samo jej przejechanie nic nie robi. Sprawdzana jest na wyniku końcowym tury: po zapisaniu punktów, po ewentualnej karze czasowej i po wyprzedzeniach. Skok ze strefy jest normalnym ruchem po torze, więc może wyprzedzić innych graczy na zwykłych zasadach: +50 dla Ciebie, −50 dla wyprzedzonego.',
  'guide.zones.chainTitle': 'Łańcuch stref',
  'guide.zones.chainBody': 'Jeśli skok ze strefy — razem z premią za wyprzedzenia, którą po drodze wywołał — postawi Twój znacznik na kolejnej strefie, ta również zadziała. I tak dalej, aż znacznik stanie poza strefami. Wyprzedzenia liczą się osobno przy każdym ogniwie łańcucha, ale tego samego przeciwnika możesz wyprzedzić najwyżej raz w turze. Jeżeli łańcuch zacznie się zapętlać, czyli trasa wróci na wynik, na którym już stała, to się kończy, a Ty zostajesz na najgorszym wyniku z tej pętli.',
  'guide.zones.limitsBody': 'Kara ze strefy nigdy nie zbije Cię poniżej zera ani poniżej progu pierwszego wejścia, czyli 50 punktów. Skok ze strefy nie podlega regule tuneli. Ogniwo, które wypchnęłoby Cię powyżej 1000, po prostu się nie wykonuje i kończy łańcuch — ukryta strefa nie może więc zepsuć tury, którą uznałeś za bezpieczną. Wyjątkiem jest trafienie strefą dokładnie w 1000: to wygrana. Z tego samego powodu podpowiedź o przekroczeniu 1000 nigdy nie uwzględnia stref.',
  'guide.app.title': 'Obsługa aplikacji',
  'guide.app.quickStartTitle': 'Szybki start online',
  'guide.app.hostTitle': 'Host (osoba zakładająca lobby)',
  'guide.app.hostStep1': 'Wejdź w Graj Online.',
  'guide.app.hostStep2': 'Wpisz swój nick i kliknij Zapisz.',
  'guide.app.hostStep4': 'Udostępnij grę przez przycisk Udostępnij link albo zaproś zaakceptowanych znajomych bezpośrednio z lobby. Możesz również dodać boty, jeśli chcesz uzupełnić skład.',
  'guide.app.hostStep5': 'Poczekaj, aż wszyscy gracze dołączą i będą gotowi.',
  'guide.app.hostStep6': 'Gdy wszyscy gracze są gotowi, host losuje kolejność i uruchamia grę.',
  'guide.app.joinTitle': 'Gracz dołączający',
  'guide.app.joinStep1': 'Kliknij otrzymany link udostępnienia albo link zaproszenia. Otworzy się okno aplikacji.',
  'guide.app.joinStep2': 'Wpisz swój nick.',
  'guide.app.joinStep3': 'Kliknij Dołącz.',
  'guide.app.joinStep4': 'Po dołączeniu status ustawiany jest automatycznie na Gotowy.',
  'guide.app.joinStep5': 'Jeśli potrzebujesz czasu, możesz zmienić status na Oczekuje.',
  'guide.app.onlineTitle': 'Tryb online',
  'guide.app.onlineBody': 'Jeden z graczy tworzy lobby, tym samym zostając gospodarzem, i udostępnia link do gry. Host może też wysyłać zaproszenia do zaakceptowanych znajomych bezpośrednio z lobby. Wszyscy dołączają, podając swoje imię. Gdy wszyscy gracze są gotowi, gospodarz uruchamia rozgrywkę. Gdy gra już trwa, nowi uczestnicy wchodzą jako widzowie; wyniki po zakończeniu są dostępne dla wszystkich.',
  'guide.app.realTitle': 'Tryb zapisu wyników',
  'guide.app.realBody': 'Można również grać prawdziwymi kośćmi, a aplikacja pilnuje zasad i liczy wszystko za Was. Dodajesz graczy, ustawiasz reguły i rozpoczynasz grę. Wpisujesz wyniki tur, a na końcu dostajesz pełne statystyki. Możesz udostępnić link do gry w trybie zapisu wyników, by inni mogli śledzić rozgrywkę na żywo.',
  'guide.app.accountTitle': 'Konto, znajomi i zaproszenia',
  'guide.app.accountBody': 'Konto w aplikacji jest opcjonalne. Po zalogowaniu przez Google lub Apple odblokujesz listę swoich gier, prywatne statystyki, listę znajomych po `friend_code` i zaproszenia do gry. Sama rozgrywka anonimowa nadal działa bez konta.',
  'guide.app.accountDetailsBody': 'W sekcji Konto otworzysz Moje wyniki z własnymi zakończonymi grami, Moje statystyki z prywatnym podsumowaniem rozgrywek oraz widok społecznościowy ze znajomymi i aktywnymi zaproszeniami. Link zaproszenia prowadzi teraz od razu do właściwego flow lobby, bez osobnego ekranu akceptacji.',
  'guide.app.accountPushBody': 'Zaproszenia do gry mogą pojawiają się u graczy jako powiadomienia. Tapnięcie w powiadomienie otwiera aplikację we właściwym lobby.',
  'guide.app.botsTitle': 'Boty',
  'guide.app.botsIntro': 'Boty pozwalają szybko uzupełnić skład, gdy brakuje żywych graczy. Bot jest pełnoprawnym uczestnikiem rozgrywki: ma swój wynik, bierze udział w kolejce tur, może wyprzedzać innych i sam może zostać wyprzedzony.',
  'guide.app.botsAddTitle': 'Jak dodać bota',
  'guide.app.botsAddBody': 'W lobby gospodarz może dodać jednego lub kilka botów przed startem gry. Bot pojawia się od razu na liście graczy i jest gotowy do gry. Jeśli dodasz kilka botów tego samego typu, aplikacja nada im odróżnialne nazwy.',
  'guide.app.botsBehaviorTitle': 'Jak zachowują się boty',
  'guide.app.botsBehaviorBody': 'Bot wykonuje swoje ruchy automatycznie, gdy przychodzi jego kolej. Sam decyduje, które punktujące kości zostawić i czy kończyć turę, czy ryzykować kolejny rzut. Bot działa według tych samych zasad co człowiek i nie dostaje żadnych ukrytych bonusów.',
  'guide.app.botsProfilesTitle': 'Profile botów',
  'guide.app.botsProfileAsekuro': 'Asekuro: gra ostrożnie, częściej zapisuje punkty i rzadziej ryzykuje długi ciąg rzutów.',
  'guide.app.botsProfileNeutralo': 'Neutralo: gra najbardziej równo, bez wyraźnego skrętu ani w nadmierną ostrożność, ani w przesadne ryzyko.',
  'guide.app.botsProfileRyzykanto': 'Ryzykanto: częściej ciśnie dalej, dłużej zostaje w turze i akceptuje większe wahania wyniku.',
  'guide.app.botsNotesTitle': 'Ważne uwagi',
  'guide.app.botsNotesBody': 'Boty nie zastępują gospodarza. To host nadal uruchamia grę i zarządza lobby. Po rozpoczęciu rozgrywki skład gry jest zamknięty tak samo jak przy zwykłych graczach. W statystykach końcowych boty są traktowane jak normalni uczestnicy i ich wyniki liczą się do pełnego podsumowania.',
  'layout.main': 'Główna sekcja',
  'layout.mainWithTitle': 'Główna sekcja: {title}',
  'gameOver.winner': 'Zwycięzca: {name}',
  'gameOver.newGame': 'Nowa gra',
  'gameOver.exitConfirm': 'Zakończyć grę i wrócić na stronę główną?',
  'gameOver.resultsMissing': 'Nie udało się wczytać wyników. Spróbuj ponownie lub otwórz stronę wyników.',
  'gameOver.openResults': 'Otwórz wyniki',
  'gameOver.resultsCalculating': 'Trwa przygotowywanie końcowych wyników…',
  'gameOver.exactThousand': 'Dokładnie 1000 Punktów',
  'gameOver.endedIn': 'Gra zakończona w {turns} turach',
  'gameOver.nextGame.starting': 'Przygotowywanie kolejnej rundy…',
  'gameOver.nextGame.startAction': 'Rozpocznij kolejną rundę',
  'gameOver.nextGame.updateError': 'Nie udało się zaktualizować udziału w kolejnej rundzie.',
  'gameOver.nextGame.selectedCount': '{count} uczestników zgłasza kolejną rundę.',
  'gameOver.nextGame.noneSelected': 'Nikt jeszcze nie zgłosił udziału w kolejnej rundzie.',
  'gameOver.nextGame.viewersPromoted': 'Widzowie wchodzący do składu: {names}',
  'gameOver.nextGame.pendingPlayers': 'Aktywni gracze bez zgłoszenia do kolejnej rundy: {names}',
  'gameOver.nextGame.hostReady': 'Host może już uruchomić kolejną rundę.',
  'gameOver.nextGame.hostNeedMin': 'Do startu kolejnej rundy potrzeba co najmniej 2 zgłoszonych uczestników.',
  'gameOver.nextGame.updating': 'Aktualizowanie…',
  'gameOver.nextGame.optOut': 'Cofnij potwierdzenie',
  'gameOver.nextGame.optIn': 'Potwierdzam udział',
  'gameOver.rankings': 'Końcowe Rankingi',
  'gameOver.winnerBadge': 'Zwycięzca!',
  'gameOver.pointsLabel': 'punktów',
  'gameOver.quickSummary': 'Szybkie podsumowanie',
  'gameOver.bestAvg': 'Najlepsza średnia / tura',
  'gameOver.bestTurn': 'Najwyższy wynik w turze',
  'gameOver.mostPenalties': 'Najwięcej kar',
  'gameOver.longestStreak': 'Najdłuższa seria dodatnich tur',
  'gameOver.gameStats': 'Statystyki Gry',
  'gameOver.totalTurns': 'Łączne Tury',
  'gameOver.overtakes': 'Wyprzedzenia',
  'gameOver.topPlays': 'Top zagrania',
  'gameOver.turnLabel': 'Tura {turn}',
  'gameOver.raceTitle': 'Wyścig punktów',
  'gameOver.play': 'Odtwórz',
  'gameOver.pause': 'Pauza',
  'turn.save': 'Zapisz',
  'turn.tunnelNeed': 'Brakuje {need}',
  'turn.overWin': 'Fura!',
  'turn.roll': 'Rzuć',
  'turn.rollAgain': 'Rzuć ponownie',
  'turn.instruction': 'Wybierz kości punktujące, aby rzucać dalej.',
  'game.roll.pointsOnTable': '{points} pkt',
  'game.roll.keepRequired': 'Wybierz przynajmniej jedną punktującą kość.',
  'game.roll.nonScoringKept': 'Na stole są niepunktujące kości – usuń je lub wybierz pełny układ.',
  'game.bank.nonScoringKept': 'Na stole są niepunktujące kości – usuń je lub wybierz pełny układ (np. cały strit).',
  'game.bank.winRequiresAllScoring': 'Aby zakończyć grę, zabierz wszystkie punktujące kości z ostatniego rzutu lub rzuć ponownie.',
  'game.bank.belowThreeScoringEndTurn': 'Aby zapisać wynik potrzebne są co najmniej trzy punktujące kości (≥3).',
  'game.bank.belowThreeScoringBank': 'Poniżej 900 wymagane ≥3 punktujące kości – to bankowanie dałoby 0.',
  'game.bank.firstEntryTooLowEndTurn': 'Pierwszy wpis musi mieć co najmniej 50 punktów.',
  'game.bank.firstEntryTooLowBank': 'Pierwszy wpis musi mieć ≥50 punktów.',
  'game.bank.freeScoringUnkept': 'Zabierz wszystkie punktujące kości zanim zapiszesz wynik.',
  'turn.segments': 'Serie punktów',
  'turn.bustBanner': 'Fura – brak punktujących kości',
  'turn.hotDice': 'Wszystkie kości punktują! (Gorące kości)',
  'turn.rescue': 'Ratunek przez 5 dostępny',
  'turn.debug.player': 'Gracz',
  'turn.debug.rolls': 'Rzuty',
  'turn.debug.current': 'Aktualny wynik',
  'turn.debug.breakdown': 'Rozpiska punktów',
  'turn.bannerDice': 'Kości z ostatniego rzutu',
      'privacy.title': 'Polityka Prywatności',
      'privacy.subtitle': 'Zasady przetwarzania danych w grze Tysiąc Kości Niezgody',
      'privacy.updated': 'Ostatnia aktualizacja: Marzec 2026',
      
      // 1. Informacje ogólne
      'privacy.general.title': '1. Informacje ogólne',
      'privacy.general.body1': 'Niniejsza aplikacja jest grą mobilną Tysiąc Kości Niezgody. Konto użytkownika jest opcjonalne: z gry można korzystać anonimowo, ale część funkcji działa po zalogowaniu przez dostawcę zewnętrznego.',
      'privacy.general.body2': 'Gra nie wykorzystuje reklam ani zewnętrznych narzędzi marketingowych. Dane są przetwarzane wyłącznie na potrzeby działania produktu, konta i zaproszeń do gry.',
    
      // 2. Jakie dane są zbierane
      'privacy.collected.title': '2. Jakie dane są zbierane',
      'privacy.collected.intro': 'Gra zapisuje wyłącznie dane niezbędne do działania:',
      'privacy.collected.item1': 'pseudonim (nick) podany dobrowolnie przez użytkownika,',
      'privacy.collected.item2': 'dane rozgrywki (np. przebieg gry, wyniki, czas trwania),',
      'privacy.collected.item3': 'losowy identyfikator gracza (UUID), generowany lokalnie na urządzeniu,',
      'privacy.collected.item4': 'identyfikator konta oraz dane profilowe przekazane przez wybranego dostawcę logowania, takie jak nazwa wyświetlana, avatar i w niektórych przypadkach adres e-mail,',
      'privacy.collected.item5': 'techniczne tokeny push i metadane urządzenia potrzebne do dostarczania zaproszeń do gry.',
      'privacy.collected.outro': 'Gra nie zbiera numerów telefonów, danych lokalizacyjnych ani nie sprzedaje danych osobowych. Adres e-mail jest przetwarzany tylko wtedy, gdy dostawca logowania przekaże go w ramach sesji konta.',
    
      // 3. Cel przetwarzania danych
      'privacy.purpose.title': '3. Cel przetwarzania danych',
      'privacy.purpose.intro': 'Dane są przetwarzane wyłącznie w celu:',
      'privacy.purpose.item1': 'zapisu i synchronizacji rozgrywek,',
      'privacy.purpose.item2': 'umożliwienia kontynuowania gry na tym samym urządzeniu,',
      'privacy.purpose.item3': 'udostępnienia prywatnych statystyk, listy znajomych i skrzynki zaproszeń po zalogowaniu,',
      'privacy.purpose.item4': 'dostarczania notyfikacji push związanych z zaproszeniami do gry w aplikacjach natywnych.',
    
      // 4. Przechowywanie danych
      'privacy.storage.title': '4. Przechowywanie danych',
      'privacy.storage.body1': 'Dane nie są sprzedawane ani udostępniane podmiotom trzecim w celach marketingowych. Dostawcy techniczni przetwarzają jedynie zakres niezbędny do obsługi logowania i dostarczenia notyfikacji.',
    
      // 5. Bezpieczeństwo
      'privacy.security.title': '5. Bezpieczeństwo',
      'privacy.security.body1': 'Dane są przesyłane z wykorzystaniem szyfrowania (HTTPS/TLS).',
      'privacy.security.body2': 'Dostęp do danych jest ograniczony wyłącznie do funkcjonowania gry.',
    
      // 6. Usuwanie danych
      'privacy.deletion.title': '6. Usuwanie danych',
      'privacy.deletion.intro': 'Użytkownik może w dowolnym momencie:',
      'privacy.deletion.item1': 'usunąć aplikację i wylogować się, co zatrzyma dalsze dostarczanie push na danym urządzeniu,',
      'privacy.deletion.item2': 'skontaktować się z deweloperem w celu usunięcia danych konta i zapisanych wyników,',
      'privacy.deletion.outro': 'W zgłoszeniu warto podać identyfikator gry, `friend_code` lub adres e-mail konta, aby ułatwić odnalezienie danych. Usunięcie danych jest nieodwracalne.',
    
      // 7. Kontakt
      'privacy.contact.title': '7. Kontakt',
      'privacy.contact.body': 'W sprawach związanych z prywatnością prosimy o kontakt:',
      'privacy.contact.developerLabel': 'Deweloper:',
      'privacy.contact.developerName': 'Janek Rumianek',
      'privacy.contact.email': 'dice1k@outlook.com',
    
      'terms.title': 'Regulamin',
      'terms.subtitle': 'Zasady korzystania z gry Tysiąc Kości Niezgody',
      'terms.updated': 'Ostatnia aktualizacja: Marzec 2026',
      'terms.acceptance.title': 'Akceptacja warunków',
      'terms.acceptance.body': 'Korzystając z gry Tysiąc Kości Niezgody, zgadzasz się na przestrzeganie niniejszego Regulaminu. Jeśli nie zgadzasz się z jakąkolwiek częścią warunków, nie możesz korzystać z gry.',
      'terms.usage.title': 'Korzystanie z usługi',
      'terms.usage.body': 'Tysiąc Kości Niezgody jest udostępniane do celów prywatnej rozrywki. Zgadzasz się nie nadużywać usług ani nie pomagać w tym innym. Gra może działać anonimowo albo z opcjonalnym kontem użytkownika.',
      'terms.disclaimer.title': 'Wyłączenie odpowiedzialności',
      'terms.disclaimer.body': 'Gra jest dostarczana w stanie „takim, w jakim jest”, bez żadnych gwarancji. Nie ponosimy odpowiedzialności za szkody wynikłe z korzystania z gry.',
      'terms.accounts.title': 'Konta i zaproszenia',
      'terms.accounts.body': 'Logowanie przez Google lub Apple jest opcjonalne i służy do odblokowania prywatnych statystyk, znajomych, zaproszeń oraz natywnych notyfikacji push. Odpowiadasz za korzystanie z konta zgodnie z zasadami dostawcy logowania i za niewysyłanie nadużyciowych zaproszeń do innych graczy.',
      'terms.dataDeletion.title': 'Usunięcie danych',
      'terms.dataDeletion.body': 'Jeżeli chcesz usunąć dane konta, skorzystaj z formularza dostępnego pod poniższym linkiem.',
      'terms.dataDeletion.link': 'Otwórz formularz usunięcia danych',
      'terms.changes.title': 'Zmiany',
      'terms.changes.body': 'Zastrzegamy sobie prawo do zmiany niniejszego regulaminu w dowolnym momencie. Dalsze korzystanie z gry oznacza akceptację zaktualizowanych warunków.',
      'terms.contact.title': 'Kontakt',
      'terms.contact.body': 'W sprawach wsparcia lub regulaminu prosimy o kontakt:',
      'terms.contact.developerLabel': 'Deweloper:',
      'terms.contact.developerName': 'Janek Rumianek',
      'terms.contact.email': 'dice1k@outlook.com',
    };
    
